import { exportStatusLabel } from '../exportTypes';

type Tone = 'ok' | 'warn' | 'danger' | 'neutral';

const TONES: Record<string, { tone: Tone; glyph: string }> = {
  Ready: { tone: 'ok', glyph: '✔' },
  Generated: { tone: 'ok', glyph: '✔' },
  Downloaded: { tone: 'ok', glyph: '↓' },
  ReversalRequired: { tone: 'warn', glyph: '⚠' },
  Reversed: { tone: 'neutral', glyph: '↺' },
  Superseded: { tone: 'neutral', glyph: '⇄' },
  ValidationFailed: { tone: 'danger', glyph: '✖' },
  Failed: { tone: 'danger', glyph: '✖' },
  Draft: { tone: 'neutral', glyph: '○' },
  None: { tone: 'neutral', glyph: '–' },
};

/** A status is always a WORD (plus a glyph), never colour alone. */
export function StatusBadge({ status }: { status: string }) {
  const { tone, glyph } = TONES[status] ?? { tone: 'neutral' as Tone, glyph: '•' };
  return (
    <span className={`ax-badge ax-badge--${tone}`} data-status={status}>
      <span aria-hidden="true">{glyph}</span> {exportStatusLabel(status)}
    </span>
  );
}
